/*
Wallclock dates (dates without timezone) come over the wire as UTC, e.g. "2022-12-31T00:00:00+00:00"
Convert this to the same date in local time.
*/
export const wallclockToLocal = (datestring: string): Date => {
  const utcDateTime = new Date(datestring);
  const localDateTime = new Date();
  localDateTime.setDate(utcDateTime.getUTCDate());
  localDateTime.setFullYear(utcDateTime.getUTCFullYear());
  localDateTime.setMonth(utcDateTime.getUTCMonth());
  localDateTime.setHours(utcDateTime.getUTCHours());
  localDateTime.setMinutes(utcDateTime.getUTCMinutes());
  localDateTime.setSeconds(utcDateTime.getUTCSeconds());
  localDateTime.setMilliseconds(utcDateTime.getUTCMilliseconds());
  return localDateTime;
};

export const setDateDayCeiling = (date: Date): void => {
  date.setHours(23, 59, 59, 999);
};

export const isWithinWallclockDates = (start_date_wallclock: string, end_date_wallclock: string, date: Date): boolean => {
  const localEffectiveDate = wallclockToLocal(start_date_wallclock);
  const localTerminationDate = wallclockToLocal(end_date_wallclock);
  setDateDayCeiling(localTerminationDate);
  return localEffectiveDate <= date && date <= localTerminationDate;
};
